export default __webpack_public_path__ + "static/media/shop-violet.57c7d574.svg";